<template lang="pug">
  div.atu.objects
    e-toolbar(
      :hideRemoveButton="true"
      :showViewPanel="false"
      :showTotal="true"
      :items="items"
      :hideImportBtn="true"
      :showResetSortBtn="true"
      :showExport="true"
      :endpointExport="endpointExport()"
    )

    // cuscroll disabled
    // beacuse reset page scroll postion after each table update
    e-table(
      tableWrapperClass="table"
      :items="items"
      @editItem="editItem"
      :showDeleteButton="false"
      :showCheckbox="false"
      :actionColumnWidth="170"
    )
      template(slot="name" slot-scope="props")
        div(v-if="props.row.has_children")
          div(
            v-if="!isOpened(props.row)"
            :class="getItemClass(props.row)"
            @click.stop.prevent="openChild(props.row)"
          ).item.with-actions.close
            span.arrow
            span {{props.row.name}}
          div(
            v-else
            :class="getItemClass(props.row)"
            @click.stop.prevent="closeChild(props.row)"
          ).item.with-actions.open
            span.arrow
            span {{props.row.name}}
        div(
          v-else
          :class="getItemClass(props.row)"
        ).item
          span.arrow
          span {{props.row.name}}

      div(slot="actionButtons" slot-scope="props").actions
        button.row-add(
          v-if="props.acceptCreate"
          @click.stop.prevent="createItem(props.row)"
        )
        button.row-edit(
          v-if="props.acceptEdit"
          @click.stop.prevent="editItem(props.row)"
        )
        button.row-view(
          v-else-if="props.displayViewButton"
          @click.stop.prevent="editItem(props.row)"
        ) {{$translate('Открыть')}}
        button.row-delete(
          v-if="props.acceptDelete"
          @click.stop.prevent="deleteItem(props.row)"
        )

    router-view
</template>

<script>
  import {atu, export_document} from '../../api/api-endpoints.js'
  import objectsMixin from './mixins/objects-mixin'
  import url from '../../utils/url.js'

  export default {
    mixins: [objectsMixin],
    methods: {
      createItem (item) {
        let query = {
          prevRoute: url.getRoute(this.$route, true),
          setFields: JSON.stringify({
            parent_id: item.id
          })
        }
        this.$router.push({
          name: this.$route.name + '.create',
          query
        })
      },
      endpointExport(){
        return export_document.geo(this.$route)
      },
      getDeleteUrl (id) {
        return atu.atuObjectDelete(id)
      },
      getEndpoint (route, fromRoute) {
        return atu.atuObjects(route)
      }
    }
  }
</script>

